export enum SyncState {
    UPTODATE = 'UPTODATE', // default
    OUTDATED = 'OUTDATED', // not synched recently or deleted
    VERIFIED_MISSING = 'VERIFIED_MISSING', // AKA Deleted
}
